import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Modal, Card, message } from 'antd';
import { ClockCircleOutlined, EditOutlined } from '@ant-design/icons';
import { UtilisateurService } from '../Services/UtilisateurService';
import { useNavigate } from 'react-router-dom';
import SessionModal from './Modal_Doc/SessionModal';

const Profil = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false);
  const [userData, setUserData] = useState({
    username: '',
    email: '',
    role: '',
    login: ''
  });
  const [isEditingUsername, setIsEditingUsername] = useState(false);
  const [isSuccessEditModalVisible, setIsSuccessEditModalVisible] = useState(false);
  const [isModalVisibleSession, setIsModalVisibleSession] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const gestionUsersService = new UtilisateurService();

  useEffect(() => {
    const storedUsername = localStorage.getItem('username');
    const storedEmail = localStorage.getItem('emailaddress');
    const storedRole = localStorage.getItem('role_name');
    const storedLogin = localStorage.getItem('login');

    setUserData({
      username: storedUsername || '',
      email: storedEmail || '',
      role: storedRole || '',
      login: storedLogin || ''
    });
  }, []);

  const showModal = () => setIsModalVisible(true);

  const openModal = () => setIsModalVisibleSession(true);
  const closeModal = () => setIsModalVisibleSession(false);

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  const onFinish = async (values) => {
    const payload = {
      login: userData.login,
      ...values,
    };

    try {
      await gestionUsersService.updatePasswordConnect(payload);
      setIsSuccessModalVisible(true);
    } catch (error) {
      message.error("Erreur lors de l'opération");
    }

    setIsModalVisible(false);
    form.resetFields();
  };

  const logout = () => {
    localStorage.removeItem("auth");
    localStorage.removeItem("user_connect");
    navigate("/login");
    window.location.reload(true);
  };

  const handleSuccessOk = () => {
    setIsSuccessModalVisible(false);
    logout();
  };

  const handleSuccessEdit = () => {
    setIsSuccessEditModalVisible(false);
    logout();
  };

  const toggleEditUsername = () => setIsEditingUsername(!isEditingUsername);

  const handleUsernameChange = (e) => setUserData({ ...userData, username: e.target.value });

  const saveUsername = async () => {
    const storedData = JSON.parse(localStorage.getItem('user_connect'));
    const payload = { ...storedData, username: userData.username };

    try {
      await gestionUsersService.updatePasswordUserName(userData.login, payload);
      localStorage.setItem('username', userData.username);
      localStorage.setItem('user_connect', JSON.stringify(payload));
      message.success('Nom d\'utilisateur mis à jour avec succès');
      setIsSuccessEditModalVisible(true); // Afficher le modal de succès
    } catch (error) {
      message.error('Erreur lors de la mise à jour du nom d\'utilisateur');
    }
    setIsEditingUsername(false);
  };

  return (
    <Card title="Profil">
      <p>
        Nom d'utilisateur:
        &nbsp;
        {isEditingUsername ? (
          <Input
            value={userData.username}
            onChange={handleUsernameChange}
            onBlur={saveUsername}
            onPressEnter={saveUsername}
            style={{ width: 200 }}
          />
        ) : (
          <>
            {userData.username} &nbsp; <EditOutlined onClick={toggleEditUsername} />
          </>
        )}
      </p>
      <p>Email : {userData.email}</p>
      <p>Role : {userData.role}</p>
      <Button type="dashed" icon={<ClockCircleOutlined />} className="buttonRefresh" onClick={openModal} style={{ marginBottom: 10 }}>
        Politique de session
      </Button><br />
      <Button type="primary" onClick={showModal} icon={<EditOutlined />}>
        Modifier mot de passe
      </Button>
      <Modal
        title="Modifier le mot de passe"
        open={isModalVisible}
        onCancel={handleCancel}
        footer={null}
      >
        <Form layout='vertical' onFinish={onFinish} form={form}>
          <Form.Item
            name="password"
            label="Ancien Mot de passe"
            rules={[{ required: true, message: 'Veuillez entrer votre ancien mot de passe!' }]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            name="new_password"
            label="Nouveau Mot de passe"
            rules={[{ required: true, message: 'Veuillez entrer votre nouveau mot de passe!' }]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            name="new_password_confirm"
            label="Confirmation mot de passe"
            dependencies={['new_password']}
            hasFeedback
            rules={[
              { required: true, message: 'Veuillez confirmer votre mot de passe!' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('new_password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Les deux mots de passe ne correspondent pas!'));
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item style={{ textAlign: 'right' }}>
            <Button type="primary" htmlType="submit">
              Modifier
            </Button>
          </Form.Item>
          <span style={{ color: 'red' }}>
            NB: Si vous modifiez votre mot de passe le système se déconnectera automatiquement et vous invitera à se connecter de nouveau.
          </span>
        </Form>
      </Modal>
      <Modal
        title="Succès"
        open={isSuccessModalVisible}
        onOk={handleSuccessOk}
        onCancel={() => setIsSuccessModalVisible(false)}
        okText="OK"
        cancelButtonProps={{ style: { display: 'none' } }}
      >
        <p>Mot de passe modifié avec succès. Vous allez être déconnecté.</p>
      </Modal>
      <Modal
        title="Succès"
        open={isSuccessEditModalVisible}
        onOk={handleSuccessEdit}
        onCancel={() => setIsSuccessEditModalVisible(false)}
        okText="OK"
        cancelButtonProps={{ style: { display: 'none' } }}
      >
        <p>Nom d'utilisateur modifié avec succès. Vous allez être déconnecté.</p>
      </Modal>
      <SessionModal
        visible={isModalVisibleSession}
        onClose={closeModal}
      />
    </Card>

  );
};

export default Profil;
